<template>
    <div class="rsu viewModal">
        <div class="viewModalBody">

            <v-layout row wrap class="ma-0">
                <v-flex xs12>
                    <v-flex xs12 class="form-control">
                        <div v-if="
                            !formdata.hideFromMember ||
                            (formdata.hideFromMember == true &&
                                memberData.verification != 'มี Tax ID')
                        ">
                            <div class="mb-2 mt-8 "
                                v-if="['หัวข้อ', 'title', 'พารากราฟ'].includes(formdata.questiontype)">

                                <div class="mb-2" v-if="['พารากราฟ'].includes(formdata.questiontype)">
                                    <Typography h5 semiBold color="darkGrey"
                                        :class="`mb-2 ${formdata.isRequired ? 'dataReq' : ''}`"
                                        :label="formdata.name" />
                                </div>
                                <div class="mb-2" v-if="['หัวข้อ', 'title'].includes(formdata.questiontype)">
                                    <Typography h3 semiBold color="darkGrey"
                                        :class="`mb-2 ${formdata.isRequired ? 'dataReq' : ''}`"
                                        :label="formdata.name" />
                                    <span class="errors" :class="[
                                        'ข้อความ',
                                        'กล่องข้อความ',
                                        'คำตอบสั้นๆ',
                                        'ช่องกรอกลิงก์',
                                        'ตัวเลข',
                                        'ที่อยู่',
                                        'เลื่อนลง',
                                    ].includes(formdata.questiontype)
                                        ? 'mt-2 mb-2' : ['บทความ'].includes(formdata.questiontype)
                                            ? 'mt-5 mb-5'
                                            : 'mt-2'
                                        ">
                                    </span>
                                    <v-divider style="border-color:#BECCDB" />
                                </div>
                            </div>
                            <ValidationProvider :vid="vid" :name="formdata.name" :key="formdata.name" :rules="{
                                required: formdata.isRequired,
                            }" v-slot="{ errors }">
                                <div class="mb-2"
                                    v-if="['ข้อความ', 'กล่องข้อความ', 'คำตอบสั้นๆ', 'ช่องกรอกลิงก์'].includes(formdata.questiontype)">
                                    <Typography h5 semiBold color="darkGrey"
                                        :class="`mb-2 ${formdata.isRequired ? 'dataReq' : ''}`"
                                        :label="formdata.name" />
                                    <input :name="'form' + k" v-model="value" :placeholder="formdata.questiontype === 'ช่องกรอกลิงก์'
                                        ? 'http://www.example.com'
                                        : customPlaceholder(formdata.Options)
                                        " type="text" @input="onInput" class="depainput rsu mb-0" />
                                    <span style="color: red;"> {{ errors[0] }}</span>
                                </div>

                                <div class="mb-2" v-else-if="['หลายตัวเลือก'].includes(formdata.questiontype)">
                                    <Typography h5 semiBold color="darkGrey"
                                        :class="`mb-1 ${formdata.isRequired ? 'dataReq' : ''}`"
                                        :label="formdata.name" />
                                    <v-radio-group class="ma-0 d-block" v-model="value"
                                        :error-messages="errors[0] ? `กรุณาเลือกอย่างน้อย 1 ตัวเลือก` : ``"
                                        :value="value" @change="onSelectOption">
                                        <div v-for="(field, k) in formdata.fields">
                                            <v-radio class="mb-2" :key="k" :label="field.label" :value="field.label">
                                            </v-radio>
                                            <div class="pl-4" v-if="
                                                value &&
                                                selectedValue &&
                                                selectedValue.subquestion &&
                                                selectedValue.subquestion.length
                                            ">
                                                <ValidationObserver ref="observer">
                                                    <div v-for="(item, k) in selectedValue.subquestion" :key="k">
                                                        <FormDetailSubquestion v-model="item.value"
                                                            :formdata="{ formitems: field.subquestion }">
                                                        </FormDetailSubquestion>
                                                    </div>
                                                </ValidationObserver>
                                            </div>
                                        </div>
                                    </v-radio-group>
                                </div>

                                <div class="mb-2" v-else-if="['เลื่อนลง'].includes(formdata.questiontype)">
                                    <Typography h5 semiBold color="darkGrey"
                                        :class="`mb-1 ${formdata.isRequired ? 'dataReq' : ''}`"
                                        :label="formdata.name" />
                                    <v-select class="questiontype-v-select" v-model="nativeSelectedItems"
                                        :error-messages="errors[0] ? `กรุณาเลือกอย่างน้อย 1 ตัวเลือก` : ``"
                                        :value="value" outlined item-text="label" dense solo @change="onInput"
                                        :items="formdata.fields" append-icon="mdi-chevron-down">
                                        <template v-slot:item="{ active, item, attrs, on }">
                                            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <div class="mediumBlue fs16 bold5">{{ item.label }}</div>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </div>

                                <div class="mb-2" v-else-if="['วัน/เวลา'].includes(formdata.questiontype)">
                                    <Typography h5 semiBold color="darkGrey"
                                        :class="`mb-2 ${formdata.isRequired ? 'dataReq' : ''}`"
                                        :label="customDateOptions(formdata.Options)" />
                                    <v-layout row wrap class="ma-0">
                                        <v-row>
                                            <v-col v-if="['all', 'date'].includes(formdata.Options)" class="col-sm-6"
                                                :class="formdata.Options === 'all' ? 'col-6' : 'col-12'">
                                                <div class="mt-2 mb-5">
                                                    <date-picker :append-to-body="false" :clearable="false" name="Date"
                                                        :popup-style="isReadonly ? { visibility: 'hidden' } : {}"
                                                        :editable="isReadonly" v-model="valueData" valueType="date"
                                                        format="DD/MM/YYYY" placeholder="เลือกวันที่เริ่ม" confirm>
                                                        <template v-slot:footer="{ emit }">
                                                            <div style="text-align: left">
                                                                <button class="mx-btn mx-btn-text"
                                                                    @click="emit(new Date())">
                                                                    Today
                                                                </button>
                                                            </div>
                                                        </template>
                                                    </date-picker>

                                                    <div v-if="errors && errors.length"
                                                        class="error--text v-messages v-messages__message  my-2 ">
                                                        <span class="errorMs" v-if="formdata.Options === 'all'">
                                                            {{ `กรุณาเลือก วันที่` }}</span>
                                                        <span class="errorMs" v-else>
                                                            {{ `กรุณาเลือก ${formdata.name}` }}</span>
                                                    </div>
                                                </div>
                                            </v-col>
                                            <v-col v-if="['all', 'time'].includes(formdata.Options)" class="col-sm-6"
                                                :class="formdata.Options === 'all' ? 'col-6' : 'col-12'">
                                                <div class="mt-2 mb-5">
                                                    <date-picker :append-to-body="false" :clearable="false" name="Time"
                                                        :popup-style="isReadonly ? { visibility: 'hidden' } : {}"
                                                        :editable="isReadonly" v-model="valueData2" type="time"
                                                        format="HH:mm" value-type="format" :value="value2"
                                                        placeholder="เลือกเวลา" confirm>
                                                    </date-picker>

                                                    <div v-if="errors && errors.length"
                                                        class="error--text v-messages v-messages__message  my-2 ">
                                                        <span class="errorMs" v-if="formdata.Options === 'all'">
                                                            {{ `กรุณาเลือก เวลา` }}</span>
                                                        <span class="errorMs" v-else>
                                                            {{ `กรุณาเลือก ${formdata.name}` }}</span>
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-layout>
                                </div>

                                <div class="mb-2" v-else-if="['ช่องทำเครื่องหมาย'].includes(formdata.questiontype)">
                                    <Typography h5 semiBold color="darkGrey"
                                        :class="`mb-1 ${formdata.isRequired ? 'dataReq' : ''}`"
                                        :label="formdata.name" />
                                    <div v-for="(field, k) in formdata.fields" :key="k">
                                        <v-checkbox v-model="nativeSelectedItems" :value="field.label"
                                            @change="onInputArray" outlined hide-details dense :error-messages="errors"
                                            :label="field.label" class="ma-0 mb-2">
                                        </v-checkbox>
                                        <div class="pl-4" v-if="
                                            nativeSelectedItems.includes(field.label) &&
                                            field.subquestion &&
                                            field.subquestion.length
                                        ">
                                            <ValidationObserver ref="observer">
                                                <FormAddDetailSubquestion :formdata="{ formdatas: field.subquestion }"
                                                    :showPreview="true">
                                                </FormAddDetailSubquestion>
                                            </ValidationObserver>
                                        </div>
                                    </div>
                                    <div v-if="errors && errors.length"
                                        class="error--text v-messages v-messages__message  my-2 ">
                                        <span class="errorMs"> กรุณาเลือกอย่างน้อย 1 ตัวเลือก</span>
                                    </div>
                                </div>

                                <div class="mb-2" v-else-if="['ตัวเลข'].includes(formdata.questiontype)">
                                    <v-flex xs12 style="display: flex;" class="mb-1">
                                        <Typography h5 semiBold color="darkGrey" class="mr-1" :label="formdata.name" />
                                        <Typography h5 semiBold color="color-lightMediumGrey"
                                            :label="`(กรุณาใส่ตัวเลข${formdata.digitPosition}หลัก)`"
                                            :class="`${formdata.isRequired ? 'dataReq' : ''}`" />
                                    </v-flex>
                                    <v-textarea :name="'form' + k" :error-messages="errors"
                                        :placeholder="customPlaceholder(formdata.Options)" outlined no-resize rows="1"
                                        auto-grow dense v-model="valueData" @keypress="isNumber($event)"
                                        :maxlength="formdata.digitPosition" class="depainput rsu mb-0"></v-textarea>
                                </div>

                                <div class="mb-2" v-else-if="['ตัวอย่างไฟล์'].includes(formdata.questiontype)">
                                    <Typography h5 semiBold color="darkGrey"
                                        :class="`mb-1 ${formdata.isRequired ? 'dataReq' : ''}`"
                                        :label="formdata.name" />
                                    <v-btn :href="formdata.fileurl" target="_blank" class="rsu customExamfileBtn ma-0"
                                        round depressed>
                                        <img :src="`/static/icon/fileSvg.svg`" alt class="responsive-img" />
                                        <Typography h5 bold color="color-mediumBlue" class="customBtnText"
                                            :label="formdata.filename" />
                                    </v-btn>
                                </div>

                                <div class="mb-2" v-else-if="['แนบลิงก์'].includes(formdata.questiontype)">
                                    <Typography h5 semiBold color="darkGrey"
                                        :class="`mb-1 ${formdata.isRequired ? 'dataReq' : ''}`"
                                        :label="formdata.name" />
                                    <a :href="formdata.URL" target="_blank">
                                        <Typography h5 medium color="color-primary" class="mt-1 linkText"
                                            :label="formdata.URL" />
                                    </a>
                                </div>

                                <div class="mb-2" v-else-if="['รูปภาพ'].includes(formdata.questiontype)">
                                    <Typography h5 semiBold color="darkGrey"
                                        :class="`mb-1 ${formdata.isRequired ? 'dataReq' : ''}`"
                                        :label="formdata.name" />
                                    <v-flex xs10>
                                        <img :src="formdata.imgFile" alt class="responsive-img w-80" />
                                    </v-flex>
                                </div>

                                <div class="mb-2" v-else-if="['รายการผลิตภัณฑ์'].includes(formdata.questiontype)">
                                    <Typography h5 semiBold color="darkGrey"
                                        :class="`mb-1 ${formdata.isRequired ? 'dataReq' : ''}`"
                                        :label="formdata.name" />
                                    <v-radio-group :error-messages="errors[0] ? `กรุณาเลือกอย่างน้อย 1 ตัวเลือก` : ``
                                        " v-bind:value="(formdata.Options = formdata.Options || 'เลือกผลิตภัณฑ์ที่มีิอยู่ในร้าน')
                                            " v-on:change="formdata.Options = $event" class="mt-0 d-block">
                                        <v-radio checked color="primary" label="เลือกผลิตภัณฑ์ที่มีิอยู่ในร้าน"
                                            :value="'เลือกผลิตภัณฑ์ที่มีิอยู่ในร้าน'"></v-radio>
                                        <DropdownMenu v-if="formdata.Options == 'เลือกผลิตภัณฑ์ที่มีิอยู่ในร้าน'"
                                            :textLabel="''" :options="[]">
                                            <div style="position: relative" class="form-control">
                                                <input placeholder="เลือกผลิตภัณฑ์" type="text" class="option-input rsu"
                                                    style="cursor: pointer" />
                                            </div>
                                        </DropdownMenu>
                                        <v-radio color="primary" label="เพิ่มผลิตภัณฑ์ใหม่"
                                            :value="'เพิ่มผลิตภัณฑ์ใหม่'"></v-radio>
                                        <v-btn v-if="formdata.Options == 'เพิ่มผลิตภัณฑ์ใหม่'"
                                            class="rsu customConfirmBtn ma-0 uploadBtn" round depressed color="primary">
                                            <img :src="`/static/icon/addYellowSvg.svg`" alt class="responsive-img mr-2"
                                                style="height: 17px;" />
                                            เพิ่มผลิตภัณฑ์
                                        </v-btn>
                                    </v-radio-group>
                                </div>

                                <div v-else-if="
                                    ['อัปโหลดเอกสาร', 'อัปโหลดไฟล์', 'อัปโหลดลายเซ็น'].includes(formdata.questiontype)
                                ">
                                    <div>
                                        <div class="header-form">
                                            <Typography h5 semiBold color="darkGrey"
                                                :class="`mb-1 ${formdata.isRequired ? 'dataReq' : ''}`"
                                                :label="formdata.name" />
                                        </div>
                                        <div class="form-control">
                                            <div style="position: relative">
                                                <input
                                                    :value="formdata.value ? formdata.value.length + ' ' + 'ไฟล์' : '0 ไฟล์'"
                                                    class="depainput rsu pl-5" readonly type="text"
                                                    style="display:none;" />

                                                <UploadDocument v-model="formdata.value"
                                                    @onUploaded="onClickUploadFile($event)" v-validate="'required'"
                                                    :multiple="`${formdata.isMultiple ? formdata.isMultiple : false}`"
                                                    :showOnlyButton="true">
                                                    <template v-slot="{ loading }">
                                                        <v-btn class="rsu customConfirmBtn ma-0 uploadBtn" round
                                                            depressed color="primary" :loading="loading">
                                                            <img :src="`/static/icon/uploadYellowSvg.svg`" alt
                                                                class="responsive-img mr-2" style="height: 13px;" />
                                                            {{ formdata.questiontype }}
                                                        </v-btn>
                                                    </template>
                                                </UploadDocument>
                                                <div v-if="formdata.value"
                                                    style="font-weight: 500;font-size: 12px;color: #BDBDBD;margin-top: 10px;">
                                                    (จำนวนไฟล์ที่อัปโหลดแล้ว : {{ formdata.value.length }} ไฟล์)
                                                </div>
                                                <div v-else
                                                    style="font-weight: 500;font-size: 12px;color: #BDBDBD;margin-top: 10px;">
                                                    (จำนวนไฟล์ที่อัปโหลดแล้ว : 0 ไฟล์)
                                                </div>
                                                <div v-if="errors && errors.length"
                                                    class="error--text v-messages v-messages__message mt-1">
                                                    <span class="errorMs"> กรุณา {{ formdata.name }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-for="(item, index) in formdata.value" :key="index" style="width: 100%">
                                        <div class="text-truncate"
                                            style="display:flex;flex-direction: row;gap:8px;align-items: center;">
                                            <span
                                                style="font-size: 12px;font-weight:700; color:#26588B; cursor: pointer;"
                                                @click="showItem(item)">
                                                {{ showNameFormLink(item) }}
                                            </span>
                                            <span @click="deleteItem(index)">
                                                <img src="/static/img/delete.png" alt
                                                    style="width:13px;height:15px;cursor: pointer;" />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-2" v-if="['ตาราง'].includes(formdata.questiontype)">
                                    <ValidationObserver ref="observer">
                                        <Typography h5 semiBold color="darkGrey"
                                            :class="`mb-1 ${formdata.isRequired ? 'dataReq' : ''}`"
                                            :label="formdata.name" />
                                        <v-flex xs12 v-if="formdata.formTable.data.length">
                                            <template>
                                                <v-layout row wrap class="ma-0">
                                                    <div class="generate-table-container">
                                                        <table class="form-generate-table">
                                                            <thead>
                                                                <tr>
                                                                    <th v-for="(header, headerIndex) in formdata.formTable.data[0]"
                                                                        :key="headerIndex" :class="!formdata.formTable.viewColumn && headerIndex === 0
                                                                            ? 'd-none'
                                                                            : ''
                                                                            ">
                                                                        <v-text-field v-if="headerIndex === 0" solo
                                                                            v-model="formdata.formTable.data[0][headerIndex]"
                                                                            class="editTextTable firstItem rsu"
                                                                            single-line>
                                                                        </v-text-field>
                                                                        <v-text-field v-if="headerIndex != 0" solo
                                                                            v-model="formdata.formTable.data[0][headerIndex]"
                                                                            class="editTextTable rsu" single-line>
                                                                        </v-text-field>
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(row, rowIndex) in formdata.formTable.data.slice(1)"
                                                                    :key="rowIndex">
                                                                    <td v-for="(column, columnIndex) in row"
                                                                        :key="columnIndex" :class="!formdata.formTable.viewColumn && columnIndex === 0
                                                                            ? 'd-none'
                                                                            : ''
                                                                            ">
                                                                        <v-text-field v-if="columnIndex === 0" solo
                                                                            v-model="formdata.formTable.data[rowIndex + 1][0]"
                                                                            class="editTextTable rsu" single-line>
                                                                        </v-text-field>
                                                                        <v-text-field v-else solo
                                                                            v-model="formdata.formTable.data[rowIndex + 1][columnIndex]"
                                                                            class="editTextTable rsu" single-line>
                                                                        </v-text-field>

                                                                        <ValidationProvider v-else
                                                                            :vid="`table[${rowIndex}][${columnIndex}]`"
                                                                            :name="`table[${rowIndex}][${columnIndex}]`"
                                                                            :key="`table[${rowIndex}][${columnIndex}]`"
                                                                            :rules="{
                                                                                required: true,
                                                                            }" v-slot="{ errors }">
                                                                            <div class="error--text ">
                                                                                <v-text-field :readonly="isReadonly"
                                                                                    solo v-model="formdata.formTable.data[rowIndex + 1][
                                                                                        columnIndex
                                                                                    ]
                                                                                        " class="editTextTable rsu"
                                                                                    single-line :style="errors && errors.length
                                                                                        ? ' border-bottom: 1px solid red !important'
                                                                                        : ''
                                                                                        ">
                                                                                </v-text-field>
                                                                            </div>
                                                                        </ValidationProvider>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </v-layout>
                                            </template>
                                        </v-flex>
                                    </ValidationObserver>
                                </div>

                                <div class="mb-2" v-if="['ที่อยู่'].includes(formdata.questiontype)">
                                    <Typography h5 semiBold color="darkGrey"
                                        :class="`mb-1 ${formdata.isRequired ? 'dataReq' : ''}`"
                                        :label="formdata.name" />
                                    <v-layout row wrap class="ma-0">
                                        <v-flex xs12 class="mb-2">
                                            <ValidationProvider :vid="vid" :name="'บ้านเลขที่'" :key="'บ้านเลขที่'"
                                                :rules="{
                                                    required: formdata.isRequired || true,
                                                }" v-slot="{ errors }">
                                                <v-textarea class="questiontype-v-textarea" no-resize rows="1" auto-grow
                                                    row-height="5" :error-messages="errors" v-model="address.addressno"
                                                    outlined dense placeholder="บ้านเลขที่">
                                                </v-textarea>
                                            </ValidationProvider>
                                        </v-flex>
                                        <v-flex xs6 class="mb-2 pr-2">
                                            <input :name="'รหัสไปรษณีย์' + k" placeholder="(รหัสไปรษณีย์)" type="text"
                                                class="depainput rsu mb-0" /></v-flex>
                                        <v-flex xs6 class="mb-2 pl-2">
                                            <input :name="'จังหวัด' + k" placeholder="(จังหวัด)" type="text"
                                                class="depainput rsu mb-0" /></v-flex>
                                        <v-flex xs6 class="mb-2 pr-2">
                                            <input :name="'แขวง/ตำบล' + k" placeholder="(แขวง/ตำบล)" type="text"
                                                class="depainput rsu mb-0" /></v-flex>
                                        <v-flex xs6 class="mb-2 pl-2">
                                            <input :name="'เขต/อำเภอ' + k" placeholder="(เขต/อำเภอ)" type="text"
                                                class="depainput rsu mb-0" /></v-flex>
                                    </v-layout>
                                </div>

                            </ValidationProvider>
                        </div>
                    </v-flex>
                </v-flex>
            </v-layout>
        </div>
    </div>
</template>

<script>
import Typography from '@/components/elements/Typography.vue'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
import DropdownMenu from '@/components/elements/DropdownMenu.vue'
import uploadfile from '@/components/elements/uploadfile.vue'
import FormAddDetailSubquestion from './FormAddDetailSubquestion.vue'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import CustomTimepicker from '@/components/elements/CustomTimepicker.vue'
import UploadDocument from '@/components/elements/UploadDocument.vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from 'moment'
import {
    ValidationProvider,
    ValidationObserver,
    Validator,
} from "vee-validate";

export default {
    props: {
        vid: {},
        value: {
            default: null,
        },
        value2: {
            default: null,
        },
        formTable: {
            type: Object,
            default: () => { },
        },
        errors: {
            default: null,
        },
        formdata: {
            default: null,
        },
        readonly: {
            default: false,
        },
        OptionsProps: {
            default: false,
        },
        Options2: {
            default: false,
        },
        cap: {
            default: false,
        },
        paidcap: {
            default: false,
        },
        shopInfo: {
            default: {},
        },
        productInfo: {
            default: {},
        },
        showInPage: {
            type: Boolean,
            default: false,
        },
        memberData: {
            default: null,
        },
    },


    components: {
        AutoresizeTextarea,
        DropdownMenu,
        uploadfile,
        FormAddDetailSubquestion,
        DatepickerCustomDialog,
        CustomTimepicker,
        Typography,
        DatePicker,
        UploadDocument,
        ValidationProvider,
        ValidationObserver,
        Validator
    },
    data() {
        return {
            defaultAnswerOptions: [
                { label: '(ไม่มี)', value: '' },
                { label: 'ชื่อ', value: 'name' },
                { label: 'อีเมล', value: 'email' },
                { label: 'เบอร์โทรศัพท์', value: 'phone_number' },
                { label: 'หมายเลขบัตรประชาชน', value: 'id_card' },
                { label: 'เลขทะเบียนนิติบุคคล', value: 'id_card2' },
                { label: 'เลขประจำตัวผู้เสียภาษีอากร', value: 'id_card3' },
                { label: 'ทุนจดทะเบียน', value: 'regis_cap' },
                { label: 'ประเภทนิติบุคคล', value: 'membertype' },
                { label: 'Project Name', value: 'project_name' },
                { label: 'Member Type', value: 'membertype2' },
                { label: 'DP Status', value: 'dptype' },
                { label: 'Register Capital', value: 'RegisterCapital' },
                { label: 'Paid Register Capital', value: 'PaidRegisterCapital' },
                { label: 'เลขเกษตรกร', value: 'farmer_number' },
                { label: 'Member ID', value: 'u_memberid' },
                { label: '[Tech hunt] รหัสคูปอง (voucher)', value: 't_product_voucher' },
                { label: '[Tech hunt] ชื่อร้านค้า (DP) ', value: 't_shop_name' },
                { label: '[Tech hunt] ชื่อสินค้า', value: 't_product' },
                { label: '[Tech hunt] ประเภทสินค้า', value: 't_product_type' },
                { label: '[Tech hunt] หมวดหมู่สินค้า', value: 't_product_category' },
                { label: '[Tech hunt] member id ของ DP', value: 'shop_memberid' },
                { label: '[Tech hunt] เลขทะเบียนนิติบุคคลของ DP', value: 'shop_juristic_id' },
                { label: '[Tech hunt] หน่วยร่วม', value: 'agency' }
            ],
            defaultDateOptions: [
                { label: 'วันที่และเวลา', value: 'all' },
                { label: 'วันที่', value: 'date' },
                { label: 'เวลา', value: 'time' }
            ],
            nativeSelectedItems: this.value ? [...this.value] : [],

            menu: false,

            optionsStatus: ['กล่องข้อความ', 'หลายตัวเลือก', 'เลื่อนลง', 'ช่องทำเครื่องหมาย'],
            input: {
                name: '',
                questiontype: 'ช่องทำเครื่องหมาย',
                fields: [''],
                fields2: ['']
            },
            currentPage: 0,
            totalPage: 1,
            Options: "",
            seted: false,
        }
    },

    watch: {
        Options: {
            deep: true,
            immediate: true,
            handler() {
                if (this.Options2 == "current_date") {
                    if (this.Options == "all") {
                        this.valueData = moment(new Date()).format("YYYY-MM-DD");
                        this.valueData2 = moment(new Date()).format("HH:mm");
                    } else if (this.Options == "date") {
                        this.valueData = moment(new Date()).format("YYYY-MM-DD");
                    } else if (this.Options == "time") {
                        this.valueData2 = moment(new Date()).format("HH:mm");
                    }
                }
            },
        },
        valueData: {
            handler() {
                if (
                    this.cap &&
                    this.Options == "regis_cap" &&
                    !this.valueData &&
                    !this.seted
                ) {
                    this.seted = true;
                    this.valueData = this.cap;
                }
                if (
                    this.cap &&
                    this.Options == "RegisterCapital" &&
                    !this.valueData &&
                    !this.seted
                ) {
                    this.seted = true;
                    this.valueData = this.cap;
                }

                if (
                    this.paidcap &&
                    this.Options == "PaidRegisterCapital" &&
                    !this.valueData &&
                    !this.seted
                ) {
                    this.seted = true;
                    this.valueData = this.paidcap;
                }
                if (
                    this.shopInfo &&
                    this.shopInfo.memberid &&
                    this.Options == "shop_memberid" &&
                    !this.valueData &&
                    !this.seted
                ) {
                    this.seted = true;
                    this.valueData = this.shopInfo.memberid;
                }
                if (
                    this.shopInfo &&
                    this.shopInfo.JuristicID &&
                    this.Options == "shop_juristic_id" &&
                    !this.valueData &&
                    !this.seted
                ) {
                    this.seted = true;
                    this.valueData = this.shopInfo.JuristicID;
                }
            },
        },
    },
    async mounted() {
        this.defaultTextInput();
    },
    computed: {
        selectedValue() {
            if (this.value) {
                return this.formdata.fields.find(el => el.label == this.value)
            }
        },
        valueData: {
            get() {
                if (this.formdata.questiontype === "วัน/เวลา") {
                    let dateFormat = moment(this.value).toDate();
                    return dateFormat;
                }
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
    },

    methods: {
        customPlaceholder(text) {
            for (let i = 0; i < this.defaultAnswerOptions.length; i++) {
                if (this.defaultAnswerOptions[i].value === text) {
                    if (text != ('(ไม่มี)' && '' && null && undefined)) {
                        return `${this.defaultAnswerOptions[i].label}`
                    } else {
                        return ``
                    }
                }
            }
        },
        customDateOptions(text) {
            for (let i = 0; i < this.defaultDateOptions.length; i++) {
                if (this.defaultDateOptions[i].value === text) {
                    return `${this.defaultDateOptions[i].label}`
                }
            }
        },
        addressInputValue(formdata, type) {
            let address = {
                addressno: '',
                district: '',
                amphoe: '',
                province: '',
                zipcode: ''
            }

            if (formdata && formdata.value && type) {
                try {
                    address = JSON.parse(formdata.value)
                    if (address.hasOwnProperty(type)) {
                        return address[type]
                    }
                } catch (error) { }
            }
            return ''
        },
        textInputValue(formdata) {
            if (formdata && formdata.Options) {
                return `{ ${this.defaultAnswerOptions.find(el => el.value == formdata.Options).label} }`
            } else return formdata.value
        },
        depadateFormat(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY')
            } else return ''
        },
        showItem(item) {
            window.open(item, '_blank').focus()
            // this.$liff.openWindow({
            //     url: item,
            //     external: true,
            // });
        },
        deleteItem: function (index) {
            var result = this.formdata
            var data_file = result.value
            data_file.splice(index, 1)
        },
        onInput(e) {
            this.$emit("input", e.target.value);
        },
        onSelectOption(e) {
            this.$emit("input", e);
        },
        onInputArray(e) {
            this.$emit("input", this.nativeSelectedItems);
        },
        defaultTextInput() {
            this.Options = this.OptionsProps;

            this.resultProductNewAdd = {};
            if (
                !this.valueData &&
                this.Options &&
                ["ข้อความ", "กล่องข้อความ", "คำตอบสั้นๆ"].includes(
                    this.formdata.questiontype
                )
            ) {
                if (this.Options == "project_name") {
                    this.valueData = this.$store.state.projects.projectname;
                } else if (this.Options == "name") {
                    this.valueData = this.filteredName;
                } else if (this.Options == "email") {
                    this.valueData = this.memberData.email || "";
                } else if (this.Options == "phone_number") {
                    this.valueData = this.memberData.phone_number || "";
                } else if (this.Options == "regis_cap") {
                    this.valueData = this.cap;
                } else if (this.Options == "t_shop_name") {
                    this.valueData = this.query.t_shop_name ? this.query.t_shop_name : "";
                } else if (this.Options == "t_product") {
                    this.valueData = this.query.t_product ? this.query.t_product : "";
                } else if (this.Options == "t_product_voucher") {
                    this.valueData = this.query.t_product_voucher
                        ? this.query.t_product_voucher
                        : "";
                } else if (this.Options == "farmer_number") {
                    this.valueData = this.memberData.profile_center_id
                        ? this.memberData.profile_center_id
                        : "";
                } else if (this.Options == "agency") {
                    this.valueData =
                        this.$store.state.agency && this.$store.state.agency.agencyname
                            ? this.$store.state.agency.agencyname
                            : "";
                } else if (this.Options == "u_memberid") {
                    this.valueData =
                        this.memberData && this.memberData.memberid
                            ? this.memberData.memberid
                            : "";
                } else if (this.Options == "t_product_type") {
                    this.valueData =
                        this.productInfo && this.productInfo.typename
                            ? this.productInfo.typename
                            : "";
                } else if (this.Options == "t_product_category") {
                    this.valueData =
                        this.productInfo && this.productInfo.categoryname
                            ? this.productInfo.categoryname
                            : "";
                } else if (this.Options.includes("id_card")) {
                    this.valueData = this.memberData.id_card || "";
                } else if (this.Options.includes("membertype")) {
                    this.valueData = this.memberData.membertype || "";
                } else if (this.Options === "shop_memberid") {
                    this.valueData = this.memberData.memberid || "";
                } else if (this.Options === "shop_juristic_id") {
                    this.valueData = this.memberData.id_card || "";
                } else if (this.Options === "dptype") {
                    this.valueData = this.memberData.dptype || "";
                }
            } else if (!this.valueData && this.formdata.defaultOptions) {
                if (this.formdata.questiontype == "ช่องทำเครื่องหมาย") {
                    let defaultOptiones = this.formdata.defaultOptions.filter((el) => {
                        return this.formdata.fields.some((el) => el.label);
                    });

                    this.valueData = defaultOptiones;
                    this.nativeSelectedItems = defaultOptiones;
                    this.onInputArray();
                } else if (this.formdata.questiontype == "หลายตัวเลือก") {
                    let defaultOptiones = this.formdata.fields.find(
                        (el) => el.label == this.formdata.defaultOptions
                    );

                    this.valueData = defaultOptiones ? defaultOptiones.label : "";
                }
            }
        },
        showNameFormLink(link) {
            try {
                let tempLink = decodeURI(link)
                tempLink = tempLink.split('/')
                tempLink = tempLink[tempLink.length - 1]
                tempLink = tempLink.split('')
                tempLink.shift()
                tempLink = tempLink.join('')
                return tempLink
            } catch (error) {
                return link
            }
        },
    },
    filters: {
        showFilename(value) {
            var result = value
            if (result) {
                result = result.split('/')
                result = result[4].substring(13)
            }
            return result
        }
    }
}
</script>
<style lang="scss" scoped>
.ab-close-icon {
    position: absolute;
    right: 12px;
    top: 5px;
}

.viewModal {
    border-radius: 8px;

    .viewModalHeader {
        position: sticky;
        top: 0;
        z-index: 999;
        display: flex;
        background: linear-gradient(274.72deg, #0c2f53 7.12%, #26588b 99.76%);
        box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
        border-radius: 8px 8px 0px 0px;
        padding: 22px 52px 10px 52px;
        max-height: 150px;
    }

    .viewModalSubHeader {
        position: sticky;
        top: 87px;
        z-index: 999;

        .subContainer {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 35px;
            background: linear-gradient(89.72deg, #fff200 6.51%, #ffc600 93.28%);
        }
    }

    .viewModalBody {
        padding: 10px 52px;
        // height: 30vh;
        overflow-y: auto;
    }

    .customCancelBtn {
        font-weight: 700;
        font-size: 16px;
        width: 142px;
        margin: 0 7px;
    }

    .customConfirmBtn {
        color: yellow !important;
        font-weight: 700;
        font-size: 16px;
        width: 142px;
        margin: 0 7px;
    }

    .customExamfileBtn {
        background-color: #e6f0fb !important;
        color: #26588b !important;
        font-weight: 700;
        font-size: 16px;
        width: 165px;

        .customBtnText {
            width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .dataReq {
        display: flex;
    }

    .dataReq::after {
        content: '*';
        color: red;
    }

    .uploadBtn {
        width: 185px;
    }
}

.generate-table-container {
    width: 100%;
    max-height: 350px;
    overflow-x: auto;
    overflow-y: auto;
}

.generate-table-container::-webkit-scrollbar {
    -webkit-appearance: none;
    background: #eeeeee;
    border-radius: 20px;
}

.generate-table-container::-webkit-scrollbar:vertical {
    width: 13px;
}

.generate-table-container::-webkit-scrollbar:horizontal {
    height: 13px;
}

.generate-table-container::-webkit-scrollbar-thumb {
    border-radius: 20px;
    border: 3px solid #eeeeee;
    background-color: #0c2f53;
}

table.form-generate-table {
    table-layout: fixed;
    width: max-content;

    thead {
        tr {
            border-bottom: 1px solid #d9d9d9;

            th {
                width: 162px;
                padding: 8px 0px;
                position: relative;
                border-radius: 0px;
                background-color: #eeeeee;

                img.table-ico {
                    width: 25px;
                    height: 25px;
                    cursor: pointer;
                }
            }

            th:first-child {
                background-color: #bdbdbd;
            }

            th:not(:first-child)::after {
                content: '';
                border-left: 1px solid #d9d9d9;
                position: absolute;
                height: 50%;
                left: 0;
                top: 25%;
            }
        }
    }

    tbody {
        tr {
            border-bottom: 1px solid #d9d9d9;

            td {
                padding: 8px 0px;
                border-radius: 0px;
                position: relative;

                img.table-ico {
                    width: 25px;
                    height: 25px;
                    cursor: pointer;
                }
            }

            td:first-child {
                background-color: #eeeeee;
            }

            td:not(:first-child)::after {
                content: '';
                border-left: 1px solid #d9d9d9;
                position: absolute;
                height: 50%;
                left: 0;
                top: 25%;
            }
        }
    }
}

// form เข้าโครงการ

// BW
$white: #ffffff !default;
$lightGrey: #EEEEEE !default;
$lightMediumGrey: #BDBDBD !default;
$mediumGrey: #818181 !default;
$darkGrey: #2C2C2C !default;
$blank: #000000 !default;

// Brand Color
$lightBlue01 : #E6F0FB !default;
$lightBlue02 : #BECCDB !default;
$mediumBlue : #26588B !default;
$darkBlue : #0C2F53 !default;
$lightYellow :#FFEF01 !default;
$yellow :#FFC600 !default;

$fontSize: 16px !default;
$fontSizeError: 14px !default;
$colorFont: $mediumBlue !default;
$fontWeight: 600 !default;

// State
$status : #BFBFBF !default;
$verify: #67AD5B !default;
$complete: #52C41A !default;
$error: #F10606 !default;
$warning :#FF8A00 !default;
$waiting: #FF8A00 !default;

$green1: #018959 !default;

.questiontype-v-textarea {
    .v-input__control {
        .v-text-field__slot {
            textarea {
                color: $colorFont;
                font-size: $fontSize;
                font-weight: $fontWeight;
                margin-top: 1px !important;
            }

            textarea::placeholder {
                font-size: $fontSize;
                font-weight: $fontWeight;
                color: $lightMediumGrey;
            }

        }

        .v-input__slot {
            fieldset {
                border: 1px solid $darkGrey;
                border-radius: 5px;
                max-height: 38px
            }

            .v-input__append-inner {
                .error--text {
                    color: $darkGrey !important;
                    caret-color: $darkGrey !important
                }
            }
        }

        .v-text-field__details {
            padding-left: 0px !important;
            margin-bottom: 4px !important;

            .v-messages {
                color: $error !important;
                font-size: $fontSizeError !important;
            }
        }


    }
}
</style>


// WEBPACK FOOTER //
// src/components/view/projectMaster/AddMemberForm/FormAddDetail.vue